<script setup>
import moment from "moment-timezone";
import { levelEnum, StatusEnum } from "@/utilities/enum";
moment.locale("id");
</script>

<template>
  <DefaultLayout class="!bg-slate-50">
    <v-row class="mx-3 my-2 font-inter">
      <v-alert
        type="primary"
        theme="dark"
        variant="tonal"
        closable
        border
        icon="mdi-alert-circle"
        v-if="role === levelEnum.KONTRAKTOR"
      >
        <h6 class="text-gray-800 font-medium text-sm">
          Report Information:
          <span class="font-normal">Pengisian laporan berakhir pada</span>
          {{
            moment
              .tz(moment(), "Asia/Singapore")
              .add(1, "month")
              .date(5)
              .format("DD MMMM YYYY")
          }}
          <span class="font-normal">Segera isi laporan bulanan Anda.</span>
        </h6>
      </v-alert>
      <v-col cols="12">
        <div class="flex justify-between items-end">
          <div>
            <div class="flex justify-start items-center gap-1">
              <h5
                class="text-xs text-red-600 font-semibold text-nowrap cursor-pointer"
                @click="$router.push('/dashboard-esg')"
              >
                Home
              </h5>
              <i class="mdi mdi-chevron-right text-xl"></i>
              <span class="text-xs text-black">Report List</span>
            </div>
            <h2 class="font-bold text-2xl text-[#232323] font-inter">
              Report List
            </h2>
          </div>
          <v-btn
            v-if="
              role === levelEnum.ENVIRONMENT ||
              role === levelEnum.ADMIN ||
              role === levelEnum.IMPROVEMENT
            "
            variant="outlined"
            class="capitalize border-gray-400 bg-white font-medium"
            id="download"
            height="40"
            @click="
              status !== StatusEnum.DRAFT || dataTable.items.length < 1
                ? downloadExcel()
                : ''
            "
            :disabled="
              status === StatusEnum.DRAFT || dataTable.items.length < 1
            "
          >
            <template #append>
              <img
                src="../../assets/icon/download.png"
                alt="Download Icon"
                class="h-4 w-auto"
              />
            </template>
            Download All
          </v-btn>
        </div>
        <div
          class="w-fit h-fit bg-white -ml-3 shadow-md rounded-md mt-3 overflow-hidden flex"
        >
          <div
            class="w-32 h-12 flex justify-center items-center cursor-pointer"
            :class="{
              'border-t-2 border-red-600': workAreaActive === index,
              'bg-slate-100 text-gray-500': workAreaActive !== index,
            }"
            v-for="(item, index) in workAreaArr"
            :key="index"
            @click="
              () => {
                (workAreaActive = index), getEsgByContractor();
              }
            "
          >
            <h3 class="text-sm font-medium -mt-2">{{ item }}</h3>
          </div>
        </div>
        <v-row
          class="mb-3 bg-white shadow-md p-2 rounded-md relative"
          v-if="role === levelEnum.KONTRAKTOR"
        >
          <v-col cols="4">
            <div
              class="bg-slate-100 rounded-md px-3 py-1 gap-x-2 flex min-h-12 h-12 w-full justify-between items-center"
            >
              <div
                class="min-w-6 w-6 h-6 rounded-md flex items-center justify-center"
                :class="{
                  'bg-gray-400 cursor-not-allowed': startIndexYear === 0,
                  'bg-gray-800 cursor-pointer': startIndexYear !== 0,
                }"
                @click="prevPageYear"
              >
                <span class="mdi mdi-arrow-left text-white text-lg"></span>
              </div>
              <div
                class="w-full justify-center h-full items-center flex gap-2"
                ref="years"
              >
                <div
                  v-for="item in visibleYears"
                  :key="item"
                  class="rounded-md cursor-pointer"
                  :class="{
                    'border-[2px] border-red-500': item.title == year,
                    'border-[2px] border-slate-100': item.title != year,
                  }"
                  @click="getEsgByContractor(item)"
                >
                  <h6 class="m-0 px-3 py-2">{{ item.title }}</h6>
                </div>
              </div>
              <div
                class="min-w-6 w-6 h-6 rounded-md flex items-center justify-center"
                :class="{
                  'bg-gray-400 cursor-not-allowed':
                    startIndexYear + visibleYearCount >= years.length,
                  'bg-gray-800 cursor-pointer':
                    startIndexYear + visibleYearCount < years.length,
                }"
                @click="nextPageYear"
              >
                <span class="mdi mdi-arrow-right text-white text-lg"></span>
              </div>
            </div>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              color="#475569"
              clearable
              hide-details
              density="compact"
              placeholder="Cari berdasarkan bulan"
              :items="months"
              v-model="month"
              item-title="title"
              item-value="value"
              class="h-full items-center w-full"
              @update:model-value="getEsgByContractor()"
            >
            </v-autocomplete>
          </v-col>
          <v-col cols="4">
            <v-autocomplete
              variant="outlined"
              clearable
              hide-details
              color="#475569"
              density="compact"
              :items="statusArr"
              v-model="status"
              placeholder="Cari berdasarkan status"
              class="w-full h-full items-center"
              @update:model-value="getEsgByContractor()"
            >
            </v-autocomplete>
          </v-col>

          <v-col cols="4" v-for="(data, index) in listEsg" :key="index">
            <CardMonthComponent
              :data="data"
              :work-area="workAreaArr[workAreaActive]"
              :year="year"
              :is-pjo="userData.isPjo"
            />
          </v-col>
        </v-row>
        <div
          class="w-full bg-white shadow-md p-3 rounded-md my-3"
          v-if="
            role === levelEnum.ENVIRONMENT ||
            role === levelEnum.ADMIN ||
            role === levelEnum.IMPROVEMENT
          "
        >
          <div
            class="grid gap-2 mb-4"
            :class="[
              role === levelEnum.IMPROVEMENT ? 'grid-cols-4' : 'grid-cols-5',
            ]"
          >
            <div class="">
              <v-autocomplete
                variant="outlined"
                color="#475569"
                :items="years"
                v-model="year"
                item-title="title"
                item-value="value"
                hide-details
                density="compact"
                placeholder="Cari berdasarkan tahun"
                @update:model-value="fetchData({})"
                @input="getYear($event?.target?.value)"
              >
              </v-autocomplete>
            </div>
            <div class="">
              <v-autocomplete
                variant="outlined"
                color="#475569"
                :items="months"
                v-model="month"
                item-title="title"
                item-value="value"
                hide-details
                density="compact"
                placeholder="Cari berdasarkan bulan"
                @update:model-value="fetchData({})"
                @input="getMonth($event?.target?.value)"
              >
              </v-autocomplete>
            </div>
            <div class="">
              <v-autocomplete
                variant="outlined"
                color="#475569"
                rounded="xs"
                :items="areas"
                v-model="area"
                hide-details
                item-title="title"
                item-value="value"
                density="compact"
                placeholder="Cari berdasarkan area"
                @update:model-value="fetchData({})"
              >
              </v-autocomplete>
            </div>
            <div class="">
              <v-autocomplete
                variant="outlined"
                color="#475569"
                rounded="xs"
                :items="contractors"
                v-model="contractor"
                hide-details
                item-title="title"
                item-value="value"
                density="compact"
                placeholder="Cari berdasarkan kontraktor"
                @update:model-value="fetchData({})"
              >
              </v-autocomplete>
            </div>
            <div class="" v-if="role !== levelEnum.IMPROVEMENT">
              <v-autocomplete
                variant="outlined"
                color="#475569"
                :items="statusArr"
                v-model="status"
                hide-details
                density="compact"
                placeholder="Cari berdasarkan status"
                @update:model-value="fetchData({})"
              >
              </v-autocomplete>
            </div>
          </div>
          <v-data-table-server
            v-model:items-per-page="dataTable.pagination.itemsPerPage"
            :headers="dataTable.headers"
            :items="dataTable.items"
            :loading="dataTable.loading"
            :items-length="dataTable.pagination.totalItems"
            @update:options="fetchData"
          >
            <template v-slot:item="{ item, index }">
              <tr
                class="border-b border-gray-950 h-16"
                :class="{
                  'bg-gray-50': index % 2 !== 0,
                }"
              >
                <td class="py-2 font-normal text-sm">
                  <p>
                    {{ getIndex(index + 1) }}
                  </p>
                </td>
                <td class="py-2 font-normal text-sm">
                  {{ item.master_month.name + " " + item.master_year.name }}
                </td>
                <td class="py-2 font-normal text-sm">
                  {{ item.pjo }}
                </td>
                <td class="py-2 font-normal text-sm">
                  {{ item.area }}
                </td>
                <td class="py-2 font-normal text-sm">
                  {{ item.initials }}
                </td>
                <td class="py-2 font-normal text-sm text-center">
                  <div
                    class="py-2 w-full rounded px-2"
                    :class="{
                      'bg-green-100 text-green-500':
                        item.status === StatusEnum.COMPLETED,
                      'bg-orange-100 text-orange-400':
                        item.status === StatusEnum.REVISION,
                      'bg-yellow-100 text-orange-400':
                        item.status === StatusEnum.WAITING_APPROVAL,
                      'bg-gray-100 text-gray-400':
                        item.status === StatusEnum.DRAFT,
                    }"
                  >
                    <span class="text-nowrap">
                      {{ capitalized(item.status) }}
                    </span>
                  </div>
                </td>
                <td>
                  <div class="flex justify-center items-center">
                    <img
                      src="../../assets/icon/download-file.png"
                      alt="img download"
                      class="w-5 h-fit cursor-pointer"
                      v-if="item.file_validity"
                      @click="download(item.file_validity)"
                    />
                    <span class="font-medium text-center" v-else> N/A </span>
                  </div>
                </td>
                <td class="py-2 font-normal text-nowrap">
                  <span class="underline text-slate-800">
                    {{ item.filled_by }}
                  </span>
                  <p class="italic text-[10px] text-gray-500">
                    {{
                      item.updated_at
                        ? moment(item.updated_at)
                            .tz("Asia/Singapore")
                            .format("DD/MM/YYYY [-] HH:mm [(GMT +8)]")
                        : "-"
                    }}
                  </p>
                </td>
                <td>
                  <div
                    class="flex justify-between items-center gap-x-2 min-w-44"
                  >
                    <div>
                      <v-btn
                        variant="outlined"
                        class="capitalize font-medium text-xs text-slate-600 border-slate-600"
                        :disabled="item.status === StatusEnum.DRAFT"
                        @click="
                          item.status !== StatusEnum.DRAFT
                            ? clickSummary(item.id)
                            : ''
                        "
                      >
                        Summary
                      </v-btn>
                    </div>
                    <v-tooltip
                      text="Delete"
                      location="top"
                      v-if="role !== levelEnum.IMPROVEMENT"
                    >
                      <template v-slot:activator="{ props }">
                        <img
                          src="../../assets/icon/trash.png"
                          alt="trash"
                          class="w-6 min-w-6 h-auto cursor-pointer"
                          @click="clickDelete(item.id)"
                          v-bind="props"
                        />
                      </template>
                    </v-tooltip>
                    <div class="w-6 min-w-6">
                      <v-tooltip
                        :text="
                          role === levelEnum.IMPROVEMENT ? 'Detail' : 'Edit'
                        "
                        location="top"
                      >
                        <template v-slot:activator="{ props }">
                          <img
                            v-if="item.status === StatusEnum.COMPLETED"
                            :src="
                              role === levelEnum.IMPROVEMENT
                                ? require('../../assets/icon/eye.png')
                                : require('../../assets/icon/pen.png')
                            "
                            alt="trash"
                            class="w-6 h-auto cursor-pointer"
                            @click="
                              $router.push({
                                path: `/esg-report/${item?.master_year?.name}/${item.id_month}/${item.area}/${item.id}`,
                                query: buildEsgQuery(),
                              })
                            "
                            v-bind="props"
                          />
                        </template>
                      </v-tooltip>
                    </div>
                    <div
                      class="w-5 min-w-5"
                      v-if="role !== levelEnum.IMPROVEMENT"
                    >
                      <v-tooltip text="Rollback" location="top">
                        <template v-slot:activator="{ props }">
                          <img
                            v-if="item.status === StatusEnum.COMPLETED"
                            src="../../assets/icon/undo.png"
                            alt="rollback"
                            class="w-5 h-auto cursor-pointer rotate-90"
                            @click="clickRollback(item)"
                            v-bind="props"
                          />
                        </template>
                      </v-tooltip>
                    </div>
                    <div class="w-6 min-w-6">
                      <v-tooltip
                        text="Download"
                        location="top"
                        v-if="item.status !== StatusEnum.DRAFT"
                      >
                        <template v-slot:activator="{ props }">
                          <img
                            src="../../assets/icon/download.png"
                            alt="Download Icon"
                            class="h-auto w-5 cursor-pointer"
                            v-bind="props"
                            @click="downloadExcel(item)"
                          />
                        </template>
                      </v-tooltip>
                    </div>
                  </div>
                </td>
              </tr>
            </template>
            <template #no-data v-if="role === levelEnum.IMPROVEMENT">
              <div class="text-center pa-4">
                <!--  -->
                <!-- <v-icon color="grey" size="36">mdi-database-off</v-icon> -->
                <p class="text-grey mt-2">No Completed Report data available</p>
              </div>
            </template>
          </v-data-table-server>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
  <SummaryModal
    v-model="dialogSummary"
    :loading="loadingSummary"
    :form-data="formDataSummary"
    :with-sub="true"
    :is-pjo="userData.isPjo"
    :is-contractor="!Array.isArray(userData?.role)"
    @close-modal="closeModal"
  />
  <ModalDelete
    v-model="dialogDelete"
    @close-modal="closeModal"
    @delete-data="deleteData"
  />
  <RollbackModal
    v-model="dialogRollback"
    :data="formDataRollback"
    :user-data="userData"
    @close-modal="closeModal"
    @after-submit="afterRollback"
  />
  <div v-if="isLoading" class="loading-overlay" style="z-index: 2070">
    <!-- You can customize the loading content here (e.g., a spinner) -->
    <div>
      <img
        src="../../assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import util from "@/assets/js/util";
import { APP_BACKEND_ESG } from "@/constants";
import GlobalDataMixin from "@/GlobalDataMixin";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import axios from "axios";
import CardMonthComponent from "./components/CardMonthComponent.vue";
import {
  CreateDataTableObject,
  SetDataTableResponse,
} from "@/utilities/DataTableHelpers";
import { capitalized } from "@/utilities/helpers";
import SummaryModal from "./components/SummaryModal.vue";
import ModalDelete from "@/components/ModalDelete.vue";
import RollbackModal from "./components/RollbackModal.vue";
import { download, downloadReportESG } from "@/utilities/globalFunction";

const base_url = APP_BACKEND_ESG;

export default {
  name: "EsgReportPage",
  mixins: [GlobalDataMixin],
  components: {
    DefaultLayout,
    CardMonthComponent,
    SummaryModal,
    ModalDelete,
    RollbackModal,
  },
  data() {
    return {
      dataTable: CreateDataTableObject([
        { title: "", align: "start", width: "2%" },
        { title: "Periode Laporan", align: "start", width: "12%" },
        { title: "PJO", key: "pjo", align: "center", width: "11%" },
        { title: "Area", key: "area", align: "center", width: "10%" },
        {
          title: "Kontraktor",
          key: "contractor_name",
          align: "center",
          width: "10%",
        },
        { title: "Status", key: "status", align: "center", width: "10%" },
        { title: "Keabsahan", align: "center", width: "15%" },
        {
          title: "Terakhir diubah oleh",
          key: "updated_at",
          align: "start",
          width: "17%",
        },
        { title: "", align: "start", width: "13%" },
      ]),
      year: "",
      month: "",
      startIndexYear: 0,
      visibleYearCount: 3,
      years: [],
      months: [],
      areas: [
        { value: "", title: "All Area" },
        { value: "Hauling", title: "Hauling" },
        { value: "Mining", title: "Mining" },
        { value: "Project", title: "Project" },
        { value: "Port", title: "Port" },
        { value: "ROM", title: "ROM" },
        { value: "Others", title: "Others" },
      ],
      workAreaArr: [],
      workAreaActive: 0,
      contractors: [],
      listEsg: [],
      alert: false,
      status: "",
      contractor: "",
      area: "",
      role: null,
      deleteId: null,
      dialogDelete: false,
      dialogSummary: false,
      dialogRollback: false,
      loadingSummary: false,
      formDataSummary: {},
      formDataRollback: {},
      isLoading: false,
      statusArr: [],
      filtersInitialized: false,
    };
  },
  computed: {
    visibleYears() {
      return this.years.slice(
        this.startIndexYear,
        this.startIndexYear + this.visibleYearCount
      );
    },
  },
  watch: {
    years() {
      this.updateVisibleYearCount();
    },
  },
  async mounted() {
    this.role = this.userData.role.includes("ADMIN")
      ? levelEnum.ADMIN
      : this.userData.role.includes("ENVIRONMENT")
      ? levelEnum.ENVIRONMENT
      : this.userData.role.includes("IMPROVEMENT")
      ? levelEnum.IMPROVEMENT
      : levelEnum.KONTRAKTOR;
    this.statusArr = [
      { value: "", title: "All Status" },
      { value: StatusEnum.DRAFT, title: "Draft" },
      {
        value: StatusEnum.WAITING_APPROVAL,
        title:
          this.role === levelEnum.KONTRAKTOR && this.userData.isPjo
            ? "Need Approval"
            : "Waiting Approval",
      },
      { value: StatusEnum.REVISION, title: "Revision" },
      {
        value: StatusEnum.COMPLETED,
        title: this.role === levelEnum.KONTRAKTOR ? "Approved" : "Completed",
      },
    ];

    this.initFiltersFromQuery();
    this.filtersInitialized = true;

    if (this.role === levelEnum.KONTRAKTOR) {
      await this.getYear();
      this.workAreaArr = this.userData.workArea
        ? this.userData.workArea
            .replace("[", "")
            .replace("]", "")
            .split(",")
            .map((item) => item.trim())
        : [];
      if (this.workAreaArr.length) {
        await this.getEsgByContractor();
      }
      this.updateVisibleYearCount();
      this.setDefaultStartIndexYear();
      window.addEventListener("resize", this.updateVisibleYearCount);
    }
    this.getMonth();
  },
  activated() {
    if (this.filtersInitialized) {
      this.initFiltersFromQuery();
      if (this.role === levelEnum.KONTRAKTOR) {
        if (this.workAreaArr && this.workAreaArr.length) {
          this.getEsgByContractor();
        }
      } else {
        this.fetchData();
      }
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateVisibleYearCount);
  },
  methods: {
    capitalized,
    download,
    initFiltersFromQuery() {
      const q = this.$route.query;
      if (q.year !== undefined && q.year !== "") this.year = Number(q.year) || q.year;
      if (q.month !== undefined) this.month = q.month !== "" ? (Number(q.month) || q.month) : "";
      if (q.area !== undefined) this.area = q.area;
      if (q.contractor !== undefined)
        this.contractor = q.contractor !== "" ? (Number(q.contractor) || q.contractor) : "";
      if (q.status !== undefined) this.status = q.status;
      if (q.workAreaActive !== undefined && q.workAreaActive !== "")
        this.workAreaActive = Number(q.workAreaActive);
      if (q.page !== undefined && q.page !== "") {
        this.dataTable.pagination.page = Number(q.page);
      }
      if (q.itemsPerPage !== undefined && q.itemsPerPage !== "") {
        this.dataTable.pagination.itemsPerPage = Number(q.itemsPerPage);
      }
    },
    syncFiltersToUrl() {
      const query = {
        year: this.year || undefined,
        month: this.month || undefined,
        area: this.area || undefined,
        contractor: this.contractor || undefined,
        status: this.status || undefined,
        workAreaActive: this.workAreaActive > 0 ? this.workAreaActive : undefined,
        page:
          this.dataTable.pagination.page > 1
            ? this.dataTable.pagination.page
            : undefined,
        itemsPerPage:
          this.dataTable.pagination.itemsPerPage !== 10
            ? this.dataTable.pagination.itemsPerPage
            : undefined,
      };
      this.$router.replace({ query }).catch(() => {});
    },
    buildEsgQuery() {
      const q = {};
      if (this.year) q.year = this.year;
      if (this.month) q.month = this.month;
      if (this.area) q.area = this.area;
      if (this.contractor) q.contractor = this.contractor;
      if (this.status) q.status = this.status;
      if (this.workAreaActive > 0) q.workAreaActive = this.workAreaActive;
      if (this.dataTable.pagination.page > 1)
        q.page = this.dataTable.pagination.page;
      if (this.dataTable.pagination.itemsPerPage !== 10)
        q.itemsPerPage = this.dataTable.pagination.itemsPerPage;
      return q;
    },
    updateVisibleYearCount() {
      const container = this.$refs.years;
      if (container) {
        const width = container.clientWidth;
        this.visibleYearCount = Math.floor(width / 70); // Estimasi setiap item butuh 70px
      }
    },
    setDefaultStartIndexYear() {
      const latestYearIndex = this.years.indexOf(this.year);
      if (latestYearIndex !== -1) {
        this.startIndexYear = Math.max(
          0,
          latestYearIndex - this.visibleYearCount + 1
        );
      }
    },
    prevPageYear() {
      if (this.startIndexYear > 0) {
        this.startIndexYear -= 1;
      }
    },
    nextPageYear() {
      if (this.startIndexYear + this.visibleYearCount < this.years.length) {
        this.startIndexYear += 1;
      }
    },
    getIndex(index) {
      return (
        index +
        (this.dataTable.pagination.page - 1) *
          this.dataTable.pagination.itemsPerPage
      );
    },
    clickDelete(id) {
      this.deleteId = id;
      this.dialogDelete = true;
    },
    clickRollback(data) {
      this.formDataRollback = {
        id: data.id,
        id_contractor: data.id_contractor,
        month_year: data.master_month.name + " " + data.master_year.name,
        area: data.area,
        contractor_name: data.contractor_name,
        month: data.id_month,
        year: data.master_year.name,
      };
      this.dialogRollback = true;
    },
    loading(status) {
      this.isLoading = status;
    },
    async getYear(keyword = null) {
      try {
        const year = await axios.get(`${base_url}/year`, {
          params: {
            name: keyword?.trim(),
            size: -1,
          },
        });

        this.years.push(
          ...year.data.data.map((item) => ({
            title: item.name,
            value: item.id,
          }))
        );
        if (!this.year) {
          this.year = year.data.data.find(
            (item) => item.name == new Date().getFullYear()
          )?.id;
        }
      } catch (err) {
        util.showError(err);
      }
    },
    async getGroupByInitials() {
      try {
        let params = {
          source: "cms",
        };
        params.id_year = this.year;

        const response = await axios.get(
          `${base_url}/dashboard/group-by-initials`,
          {
            params: params,
          }
        );

        const result = response.data.data;

        this.contractors = [{ title: "All Kontraktor", value: "" }];
        this.contractors.push(
          ...result.map((data) => ({
            title: data.contractor_name,
            value: data.id_contractor,
          }))
        );
      } catch (err) {
        util.showError(err);
      }
    },
    async getMonth(keyword = null) {
      try {
        const month = await axios.get(`${base_url}/month`, {
          params: {
            name: keyword?.trim(),
            size: -1,
          },
        });
        if (!keyword) {
          this.months = [{ title: "All Month", value: "" }];
        }
        this.months.push(
          ...month.data.data.map((item) => ({
            title: item.name,
            value: item.id,
          }))
        );
      } catch (err) {
        util.showError(err);
      }
    },
    async getEsgByContractor(item = null) {
      try {
        let params = {
          year: item ? item.title : new Date().getFullYear(),
          id_contractor: parseInt(this.userData.kontraktorID),
          area: this.workAreaArr[this.workAreaActive],
          source: "cms",
          status: this.status,
          id_month: this.month,
        };

        this.year = params.year;
        this.syncFiltersToUrl();

        const result = await axios.get(`${base_url}/esg/by-contractor`, {
          params: params,
        });

        this.listEsg = result.data.data;
      } catch (err) {
        util.showError(err);
      }
    },
    async fetchData({ page, itemsPerPage, sortBy } = {}) {
      if (!this.years.length) {
        await this.getYear();
      }

      try {
        if (page) this.dataTable.pagination.page = page;
        if (itemsPerPage) this.dataTable.pagination.itemsPerPage = itemsPerPage;
        this.syncFiltersToUrl();

        this.dataTable.loading = true;
        let params = {
          page: this.dataTable.pagination.page,
          size: this.dataTable.pagination.itemsPerPage,
          sortBy: sortBy ? sortBy[0] : null,
          id_month: this.month,
          id_year: this.year,
          status: this.status,
          area: this.area,
          id_contractor: this.contractor,
          is_parent: true,
        };

        if (this.userData.role.includes("IMPROVEMENT")) {
          params.status = StatusEnum.COMPLETED;
        }

        const response = await axios.get(`${base_url}/esg`, {
          params: params,
        });
        this.dataTable = SetDataTableResponse(this.dataTable, response.data);
      } catch (err) {
        util.showError(err);
      } finally {
        this.getGroupByInitials();
        setTimeout(() => {
          this.dataTable.loading = false;
        }, 1000);
      }
    },
    async clickSummary(id) {
      try {
        const data = await axios.get(`${base_url}/esg/detail/${id}`);

        const response = data.data.data;
        let bodyJson = {
          id: parseInt(id),
          with_sub: true,
        };

        this.setLoadingSummary(true);
        this.dialogSummary = true;

        const res = await axios.post(`${base_url}/esg/summary`, bodyJson);

        this.formDataSummary = res.data.data;

        Object.assign(this.formDataSummary, {
          id: id,
          id_contractor: response.id_contractor,
          contractor_name: response.contractor_name,
          month: response.master_month.name,
          year: response.master_year.name,
          status: response.status,
          area: response.area,
        });
      } catch (err) {
        util.showError(err);
      } finally {
        this.setLoadingSummary(false);
      }
    },
    async deleteData() {
      this.loading(true);
      try {
        const res = await axios.delete(`${base_url}/esg`, {
          data: {
            id: this.deleteId,
          },
        });

        util.showInfo(res.data.message);
      } catch (err) {
        this.loading(false);
        util.showError(err);
      } finally {
        this.loading(false);
        this.closeModal();
        this.fetchData();
      }
    },
    async downloadExcel(item = null) {
      try {
        let bodyJson = {
          mode: "COMBINED",
          is_pjo: this.userData.isPjo ?? false,
          is_contractor: !Array.isArray(this.userData.role),
        };
        let filename = "";
        if (item) {
          bodyJson.id = item.id;

          filename =
            item.master_month.name +
            "_" +
            item.master_year.name +
            "_" +
            item.contractor_name;
        } else {
          if (this.contractor !== "") {
            bodyJson.id_contractor = this.contractor;
          }

          if (this.status !== "") {
            bodyJson.status = this.status;
          }

          if (this.userData.role.includes("IMPROVEMENT")) {
            bodyJson.status = StatusEnum.COMPLETED;
          }

          if (this.year !== "") {
            bodyJson.id_year = this.year;
          }

          if (this.month !== "") {
            bodyJson.id_month = this.month;
          }

          if (this.area !== "") {
            bodyJson.area = this.area;
          }

          const year_name = this.years.find(
            (item) => item.value === this.year
          ).title;
          const month_name = this.months.find(
            (item) => item.value === this.month
          ).title;
          const area_name = this.areas.find(
            (item) => item.value === this.area
          ).title;
          const contractor_name = this.contractors.find(
            (item) => item.value === this.contractor
          ).title;
          const status_name = this.userData.role.includes("IMPROVEMENT")
            ? capitalized(StatusEnum.COMPLETED)
            : capitalized(
                this.statusArr.find((item) => item.value === this.status).title
              );

          filename = `ESG Report_${year_name}_${month_name}_${area_name}_${contractor_name}_${status_name}`;
        }

        downloadReportESG(filename, bodyJson);
      } catch (err) {
        util.showError(err);
      }
    },
    afterRollback() {
      this.closeModal();
      this.fetchData();
    },
    closeModal() {
      this.dialogDelete = false;
      this.dialogSummary = false;
      this.dialogRollback = false;
      this.formDataSummary = {};
      this.formDataRollback = {};
      this.deleteId = null;
    },
    setLoadingSummary(status) {
      this.loadingSummary = status;
    },
  },
};
</script>

<style scoped>
:deep(thead:not(.summary)) {
  background-color: #f0f1f4;
  font-weight: 500;
  font-size: 13px;
  color: #232323;
}
</style>
